import { gql } from '@apollo/client'

import { SHOP_CART_FRAGMENT } from '../fragments'

export const UPDATE_CART = gql`
  mutation UpdateCart($utensils: Boolean) {
    updateCart(input: { utensils: $utensils }) {
      cart {
        ...ShopCart
      }
    }
  }
  ${SHOP_CART_FRAGMENT}
`
